import React from "react";
import { useSnapshot } from "valtio";

import { templateActions } from "@pages/Applications/C&C/C&CSetup/templateStore";
import { store } from "../../store";
import { ImageDisplay } from "../../../../Common/ImageDisplay";
import appStore from "@assets/images/app-store.png";
import playStore from "@assets/images/play-store.png";

export function Section4Preview({ section }: { section: string }): JSX.Element {
    const { selectedLanguage } = useSnapshot(store);
    const localData = React.useMemo(() => {
        return (
            templateActions.getNestedObject([
                "template",
                "SiteWeb",
                "LaindingPage",
                section,
            ]) || {}
        );
    }, [section]);

    const image = localData?.Image || {
        Url: "",
        Name: "",
        Type: "",
        Extenxion: "",
    };

    const backgroundColor = localData.Color ?? "#f9f9f9";

    return (
        <div
            style={{
                height: "80vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderLeft: "1px #c6c7c9 solid",
            }}
        >
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    maxWidth: "1200px",
                    overflow: "hidden",
                    alignItems: "stretch",
                    padding: "2rem",
                    height: "75%",
                    backgroundColor,
                }}
            >
                <div
                    style={{
                        flex: 1,
                        padding: "2rem",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        color: "#000",
                        marginTop: "7rem",
                    }}
                >
                    <h2
                        style={{
                            fontSize: "1.6rem",
                            fontWeight: "bold",
                            marginBottom: "1rem",
                        }}
                    >
                        {localData?.Title?.[selectedLanguage] || ""}
                    </h2>
                    <p
                        style={{
                            fontSize: "0.9rem",
                            color: "#333",
                            marginBottom: "1.5rem",
                        }}
                    >
                        {localData?.Description?.[selectedLanguage] || ""}
                    </p>
                    <div
                        className="d-flex justify-content-start"
                        style={{ height: "100%", width: "100%" }}
                    >
                        {localData?.PlayeStore?.Activer && (
                            <img
                                src={playStore}
                                alt="Get it on Google Play"
                                style={{
                                    width: "120px",
                                    height: "40px",
                                    borderRadius: "8px",
                                    marginRight: "2%",
                                }}
                            />
                        )}
                        {localData?.AppStore?.Activer && (
                            <img
                                src={appStore}
                                alt="Download on the App Store"
                                style={{
                                    width: "120px",
                                    height: "40px",
                                    borderRadius: "8px",
                                }}
                            />
                        )}
                    </div>
                </div>
                <div
                    style={{
                        flex: 1,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                    }}
                >
                    <ImageDisplay item={image} />
                </div>
            </div>
        </div>
    );
}
